var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import BaseService from '../server/BaseService';
var EbookService = /** @class */ (function (_super) {
    __extends(EbookService, _super);
    function EbookService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EbookService.prototype.getWebAuthInfo = function (options) {
        return this.fetch(__assign({ api: 'open-api/component/v1/emplSelector/auth' }, options));
    };
    EbookService.prototype.getExternalContacts = function (options) {
        var accessToken = options.accessToken, env_pre = options.env_pre, source = options.source;
        return this.fetch({
            api: 'open-api/component/v1/emplSelector/myContacts',
            params: {},
            accessToken: accessToken,
            env_pre: env_pre,
            source: source,
        });
    };
    EbookService.prototype.getSearchGlobal = function (options) {
        return this.fetch(__assign({ api: 'open-api/component/v1/emplSelector/search' }, options));
    };
    EbookService.prototype.getEbookDeptInfo = function (options) {
        return this.fetch(__assign({ api: 'open-api/component/v1/emplSelector/deptOrg' }, options));
    };
    // eslint-disable-next-line max-params
    EbookService.prototype.getUserCardDetailInfo = function (params, accessToken, env_pre, source) {
        return this.fetch({
            api: 'open-api/contact/v1/userDetail',
            params: params,
            accessToken: accessToken,
            env_pre: env_pre,
            source: source,
        });
    };
    EbookService.prototype.applyFriend = function (options) {
        return this.fetch(__assign({ api: 'open-api/contact/v1/applyFriend' }, options));
    };
    EbookService.prototype.getRecordCheck = function (options) {
        return this.fetch(__assign({ api: 'open-api/contact/v1/getRecordCheck' }, options));
    };
    return EbookService;
}(BaseService));
export default EbookService;
//# sourceMappingURL=ebook.js.map